/* ============================================================
   NAV DROPDOWN FIX — CSS + JS fallback for Warehouse theme
   ============================================================ */
(function () {
  var style = document.createElement('style');
  style.id = 'nav-dropdown-fix';
  style.textContent = `
    .header-wrapper, .header, .nav-bar {
      z-index: 200 !important;
      position: relative;
    }
    .nav-dropdown {
      position: absolute !important;
      top: 100% !important;
      left: 0 !important;
      z-index: 300 !important;
      background: #ffffff !important;
      box-shadow: 0 8px 24px rgba(0,0,0,0.12) !important;
      min-width: 220px !important;
      border-radius: 4px !important;
      padding: 8px 0 !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
      transition: opacity 0.2s ease, visibility 0.2s ease !important;
    }
    .nav-bar__link[aria-expanded="true"] + .nav-dropdown,
    .nav-bar__item:hover > .nav-dropdown,
    .nav-bar__item--has-dropdown:hover > .nav-dropdown {
      visibility: visible !important;
      opacity: 1 !important;
      pointer-events: auto !important;
    }
    .nav-dropdown li a {
      display: block !important;
      padding: 10px 20px !important;
      white-space: nowrap !important;
      color: inherit !important;
      text-decoration: none !important;
    }
    .nav-dropdown li a:hover {
      background: rgba(0,0,0,0.05) !important;
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.nav-bar__link[aria-controls]').forEach(function (link) {
      var dropdown = document.getElementById(link.getAttribute('aria-controls'));
      if (!dropdown) return;
      var parent = link.closest('.nav-bar__item') || link.parentElement;

      parent.addEventListener('mouseenter', function () {
        link.setAttribute('aria-expanded', 'true');
        dropdown.setAttribute('aria-hidden', 'false');
      });
      parent.addEventListener('mouseleave', function () {
        link.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('aria-hidden', 'true');
      });
      link.addEventListener('click', function (e) {
        if (link.getAttribute('aria-expanded') === 'true') {
          link.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-hidden', 'true');
        } else {
          e.preventDefault();
          link.setAttribute('aria-expanded', 'true');
          dropdown.setAttribute('aria-hidden', 'false');
        }
      });
    });
  });
})();





